import React from 'react';
import ProductPage from '../components/product/ProductPage';
import { bombWorldClassicConfig } from '../config/products';

const BombWorldClassicPage: React.FC = () => {
  return <ProductPage config={bombWorldClassicConfig} />;
};

export default BombWorldClassicPage;
